/**
 * Project : workspace
 * File    : NewBusinessHomeScreen.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package presentation.screens.business.home

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.parmartechnologies.communication.core.viewModel.AuthViewModel
import com.parmartechnologies.core.navigation.NavigationParam
import component.navigation.TopNavBar
import navigation.AppNavigator
import navigation.route.inventory.InventoryNavRoute
import navigation.route.relation.RelationNavRoute
import navigation.route.sale.SaleNavRoute
import navigation.route.store.StoreNavRoute
import org.jetbrains.compose.ui.tooling.preview.Preview
import presentation.screens.business.home.component.HomeManageInventoryCard
import presentation.screens.business.home.component.HomeManageRelationCard
import presentation.screens.business.home.component.HomeOnlineSaleCard
import presentation.screens.business.home.component.HomePOSCard
import presentation.screens.business.home.component.ShareQRLinkCard

/**
 * Represents the new business home screen class.
 */

class NewBusinessHomeScreen{

    @Preview
    @Composable
    fun Content() {
        val authViewModel = AuthViewModel()
        val isLoggedIn = authViewModel.isLoggedIn.collectAsState()
        Column {
            TopNavBar(
                "", NavigationParam(),
                showNotification = true
            )
            LazyColumn(
                modifier = Modifier
                    .fillMaxSize().padding(top = 8.dp ,start = 8.dp, end = 8.dp)
            ) {
                item {
                    HomePOSCard().content{
                        if(isLoggedIn.value){
                            AppNavigator.shared().navigate(SaleNavRoute.HOME)
                        }else{
                            authViewModel.showAuthContainer()
                        }
                    }
                }
                item {
                    HomeOnlineSaleCard().content{
                        if(isLoggedIn.value){
                            AppNavigator.shared().navigate(StoreNavRoute.HOME)
                        }else{
                            authViewModel.showAuthContainer()
                        }

                    }
                }
                item {
                    HomeManageInventoryCard().content {
                        if(isLoggedIn.value){
                            AppNavigator.shared().navigate(InventoryNavRoute.HOME)
                        }else{
                            authViewModel.showAuthContainer()
                        }
                    }
                }
                item {
                    HomeManageRelationCard().content {
                        if(isLoggedIn.value){
                            AppNavigator.shared().navigate(RelationNavRoute.HOME)
                        }else{
                            authViewModel.showAuthContainer()
                        }
                    }
                }
                item {
                    ShareQRLinkCard().content {

                    }
                }
            }
        }
    }
}